import Loading from './Loading';
import provideLayout from 'layout';

export default provideLayout(Loading);
